// filepath: apps/web/src/features/admin/userRoles/SyncStatusBanner.tsx
//
// FR-UI-ADM-5 AC-6 — sync-status banner.
//
// Renders when sync_status !== "ok". Embeds the SyncRetryButton.

import React from "react";
import { useTranslation } from "react-i18next";
import type { SyncStatus } from "./types";

interface SyncStatusBannerProps {
  syncStatus: SyncStatus;
  onRefresh: () => void;
  refreshing: boolean;
}

export function SyncStatusBanner({
  syncStatus,
  onRefresh,
  refreshing,
}: SyncStatusBannerProps): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      role="alert"
      data-state={`sync_${syncStatus}`}
      data-testid="sync-status-banner"
    >
      <span>{t(`admin.users.sync_status.${syncStatus}`)}</span>
      <button
        type="button"
        onClick={onRefresh}
        disabled={refreshing}
        data-testid="sync-status-refresh"
      >
        {t("admin.users.action.sync_refresh")}
      </button>
    </div>
  );
}
